import * as types from './actionsTypes';
//import { Config } from '../config/index';
//import axios from 'axios';



export const loadLatestCampaignsApi = () => async (dispatch) => {
    try {
        //const payload = await axios.get(Config.api + '/Campaigns');
        dispatch({ type: types.LATEST_CAMPAIGNS, payload: null });
    } catch (error) {
        dispatch({ type: types.LATEST_CAMPAIGNS, payload: null });
    }
};


